export default __webpack_public_path__ + "static/0010-9786fbb33f5b1159aa53abbd1bad81bc.png";